import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { BookOpen, TrendingUp, Calendar, Award } from 'lucide-react';

export function StatsGrid({ courses, bookings, userRole }) {
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-[#007AFF]/10 rounded-md flex items-center justify-center">
            <BookOpen className="w-6 h-6 text-[#007AFF]" />
          </div>
          <span className="text-[#00FF66] text-sm font-mono">{t('common.active')}</span>
        </div>
        <div className="text-3xl font-bold text-white font-mono">{courses.length}</div>
        <div className="text-[#71717A] text-sm">{t('dashboard.enrolledCourses')}</div>
      </div>

      <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-[#00FF66]/10 rounded-md flex items-center justify-center">
            <TrendingUp className="w-6 h-6 text-[#00FF66]" />
          </div>
        </div>
        <div className="text-3xl font-bold text-white font-mono">
          {courses.reduce((acc, c) => acc + (c.lessons?.length || 0), 0)}
        </div>
        <div className="text-[#71717A] text-sm">{t('dashboard.totalLessons')}</div>
      </div>

      <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-purple-500/10 rounded-md flex items-center justify-center">
            <Calendar className="w-6 h-6 text-purple-500" />
          </div>
        </div>
        <div className="text-3xl font-bold text-white font-mono">{bookings.length}</div>
        <div className="text-[#71717A] text-sm">{t('dashboard.consultingSessions')}</div>
      </div>

      <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-yellow-500/10 rounded-md flex items-center justify-center">
            <Award className="w-6 h-6 text-yellow-500" />
          </div>
        </div>
        <div className="text-3xl font-bold text-white font-mono">
          {userRole === 'admin' ? t('common.admin') : t('common.student')}
        </div>
        <div className="text-[#71717A] text-sm">{t('dashboard.accountStatus')}</div>
      </div>
    </div>
  );
}
